const BlogRecognition = () => (
  <>
    {/* ── BABY & KIND (hoge prioriteit) ────────────────────────────── */}
    <section className="py-20 bg-gradient-to-b from-[#050010] to-[#0a0018]">
      <div className="max-w-[1200px] mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="relative h-80 lg:h-full min-h-[400px] rounded-3xl overflow-hidden">
            <img
              src="https://public.readdy.ai/ai/img_res/0036a44b189ff6d6b0c1f528ee9ffd0b.jpg"
              alt="Baby onrustig 's nachts"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0a0018]/80 via-transparent to-transparent" />
            <div className="absolute bottom-5 left-5 px-4 py-2 bg-violet-600/25 backdrop-blur-sm border border-violet-500/30 rounded-xl">
              <p className="text-violet-300 text-xs font-semibold">Baby's zijn energetisch het meest gevoelig</p>
            </div>
          </div>

          <div>
            <p className="text-violet-400 text-xs font-semibold uppercase tracking-widest mb-3">✦ Hoge prioriteit ✦</p>
            <h2 className="text-3xl font-bold text-white mb-3">
              Is jouw baby of kind<br />
              <span className="text-violet-400">onrustig of angstig?</span>
            </h2>
            <p className="text-white/55 text-sm leading-relaxed mb-6">
              Kinderen — en zeker baby's — beschikken nog niet over de energetische afweermechanismen die volwassenen opbouwen.
              Ze registreren alles in hun omgeving: emoties, spanningen en energetische invloeden van buitenaf.
            </p>

            <div className="space-y-3 mb-6">
              {[
                { sign: 'Baby schrikt plotseling wakker uit een diepe slaap', level: 'sterk signaal' },
                { sign: 'Onrustig slapen met veel bewegen', level: 'signaal' },
                { sign: 'Veelvuldig huilen zonder aanwijsbare oorzaak', level: 'sterk signaal' },
                { sign: 'Moeilijk te kalmeren ondanks alle verzorging', level: 'signaal' },
                { sign: 'Angstig gedrag overdag, klampt zich vast', level: 'sterk signaal' },
                { sign: 'Overprikkeling: snel gespannen of overstuur', level: 'signaal' },
              ].map(item => (
                <div key={item.sign} className="flex items-start gap-3 p-3 bg-white/3 border border-violet-500/10 rounded-xl">
                  <div className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
                    <i className="ri-alert-line text-violet-400 text-sm" />
                  </div>
                  <div className="flex-1">
                    <p className="text-white/80 text-sm">{item.sign}</p>
                  </div>
                  <span className={`shrink-0 px-2 py-0.5 rounded-full text-xs whitespace-nowrap ${
                    item.level === 'sterk signaal'
                      ? 'bg-rose-500/15 text-rose-300 border border-rose-500/20'
                      : 'bg-violet-500/15 text-violet-300 border border-violet-500/20'
                  }`}>
                    {item.level}
                  </span>
                </div>
              ))}
            </div>

            <div className="p-4 bg-violet-600/10 border border-violet-500/25 rounded-xl">
              <p className="text-violet-200/80 text-sm leading-relaxed">
                <strong className="text-violet-300">Herken je drie of meer van deze signalen?</strong><br />
                Dan is er waarschijnlijk sprake van energetische overbelasting bij je kind.
                Dit is op te lossen — niet met angst, maar met kennis en gerichte bescherming.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* ── VOLWASSENEN ──────────────────────────────────────────────── */}
    <section className="py-20 bg-[#0a0018]">
      <div className="max-w-[1200px] mx-auto px-6">
        <div className="text-center mb-12">
          <p className="text-violet-400 text-xs font-semibold uppercase tracking-widest mb-3">✦ Niet alleen kinderen ✦</p>
          <h2 className="text-3xl font-bold text-white mb-4">
            Ook volwassenen voelen de invloed —<br />
            <span className="text-violet-400">vaak zonder het te beseffen</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mb-12">
          {[
            { icon: 'ri-battery-low-line', title: 'Chronisch energieverlies', desc: 'Uitgeput wakker worden, moeite om op te laden, constant vermoeid ondanks voldoende slaap.' },
            { icon: 'ri-mental-health-line', title: 'Aanhoudende stress of onrust', desc: 'Een gevoel van spanning dat niet wegtrekt — ook in momenten van rust of vakantie.' },
            { icon: 'ri-home-2-line', title: 'Onrust in huis', desc: 'Ruzie, spanning of een zwaar gevoel dat terugkeert na bezoek of bepaalde periodes.' },
            { icon: 'ri-group-line', title: 'Spanningen met anderen', desc: 'Conflicten met familie, vrienden of collega\'s die steeds heviger of vaker terugkeren.' },
            { icon: 'ri-ghost-line', title: 'Gevoel van aanwezigheid', desc: 'Een gevoel dat je niet alleen bent, verstoorde slaap of beelden in de nacht — bij volwassenen en kinderen.' },
            { icon: 'ri-bar-chart-decreasing-line', title: 'Zakelijke stagnatie', desc: 'Minder focus, klanten die wegblijven, projecten die niet slagen ondanks goede inspanning.' },
          ].map(item => (
            <div key={item.title} className="p-5 bg-white/3 border border-violet-500/15 rounded-2xl hover:border-violet-500/30 transition-colors">
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-violet-600/20 mb-3">
                <i className={`${item.icon} text-violet-400 text-lg`} />
              </div>
              <h3 className="text-white font-semibold text-sm mb-2">{item.title}</h3>
              <p className="text-white/45 text-xs leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        {/* Uitleg energie — nuchter */}
        <div className="max-w-3xl mx-auto p-7 bg-gradient-to-br from-violet-600/10 to-fuchsia-600/10 border border-violet-500/20 rounded-3xl">
          <h3 className="text-white font-bold text-xl mb-4 text-center">
            <i className="ri-information-line text-violet-400 mr-2" />
            Hoe werkt energetische invloed?
          </h3>
          <div className="space-y-3 text-white/60 text-sm leading-relaxed">
            <p>
              Elk mens draagt een energetisch veld om zich heen — een aura. Bij elke interactie met anderen
              vindt er een energietransfer plaats: positief én negatief. Dit is geen mystiek begrip maar een
              gegeven dat in sjamaanse tradities over de hele wereld al duizenden jaren wordt erkend.
            </p>
            <p>
              <strong className="text-violet-300">Kinderen zijn hiervoor het gevoeligst</strong> — hun energetische afweer is nog niet ontwikkeld.
              Ze absorberen alles: spanning van ouders, jaloezie van bezoekers, emoties in de omgeving.
              Dit uit zich direct in gedrag: huilen, schrikken, onrust.
            </p>
            <p>
              Volwassenen bouwen een zekere weerstand op, maar ook die heeft grenzen.
              Herhaaldelijke blootstelling aan negatieve energie — van jaloezie, conflicten of kwade intenties —
              sloopt de bescherming van het energieveld en leidt tot merkbare klachten.
            </p>
          </div>
        </div>
      </div>
    </section>
  </>
);

export default BlogRecognition;
